import React from 'react'
import GA from 'react-ga4'
import { Button, View } from 'oio-react'
import { useOrganization } from 'src/core/graphql/hooks'
import style from './style.less'

const HomeFeatures = () => {
   const { organization } = useOrganization()
   const softwareVersion = organization.metadata.find(m => m.key === 'software_version')?.value

   const homeFeature1Data = organization.metadata
      .find(m => m.key === 'home_feature_1')?.value

   // const homeFeature2Data = organization.metadata
   //    .find(m => m.key === 'home_feature_2')?.value

   const handleAnalyticsClick = (action) => {
      if (organization.tmpGoogleAnalyticsTrackingId) {
         GA.event({
            category: 'Home',
            action: `Home - ${action}`
         })
      }
   }

   return (
      <div className="w-full flex justify-center">
         <View
            display="flex"
            justifyContent="space-between"
            flexFlow="column[a-b] row[c-f]"
            width="100%"
            maxWidth="90%[a] 100%[b] 780px[c] 780px[d-f]"
            padding="0 0 32px 0px"
            // marginTop="80px"
            // borderRadius="20px"
            // boxShadow="0px 0px 100px rgba(143, 199, 232, 0.4)[d-f]""
            backgroundColor="black">
            <View
               display="flex"
               flexFlow="column"
               alignItems="center"
               textAlign="center"
               width="100%[a-b] 49%[c-f]"
               padding="32px[a-b] 48px 32px[c-f]">
               <div
                  className="ui-title-xl"
                  style={{
                     fontWeight: 'bold',
                     color: '#fff',
                     background: '-webkit-linear-gradient(#888, #fff)',
                     WebkitBackgroundClip: 'text',
                     WebkitTextFillColor: 'transparent',
                     letterSpacing: '-2px',
                     paddingBottom: '8px'
                  }}>
                  {softwareVersion}
               </div>
               <div className={style.featureTitle}>
                  Get the Latest Software
               </div>
               <div className={style.featureSubtitle}>
                  {`GNS3 ${softwareVersion} is now available`}
               </div>
               <Button
                  linkTo="/software/download"
                  color="#282828"
                  name="Download Now"
               />
            </View>
            <View
               display="flex"
               flexFlow="column"
               alignItems="center"
               textAlign="center"
               width="100%[a-b] 49%[c-f]"
               padding="32px[a-b] 16px 32px[c-f]"
               // borderRight="1px solid #222[c-f]"
               borderLeft="1px solid #222[c-f]">
               <img
                  width="64px"
                  src="/assets/custom/gns3/images/home/1-circle.jpg"
                  alt="Course"
               />
               <div className={style.featureTitle}>
                  <div className={style.highlightBlue}>
                     {homeFeature1Data?.title}
                  </div>
                  {homeFeature1Data?.subtitle}
               </div>
               <div className={style.featureSubtitle}>
                  {homeFeature1Data?.body}
               </div>
               {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
               <a
                  href={homeFeature1Data?.url}
                  onClick={() => {
                     handleAnalyticsClick(`${homeFeature1Data?.title} - Homepage Ad Click`)
                  }}
                  rel="noopener noreferrer"
                  target="_blank">
                  <Button
                     color="#616dfb"
                     // eslint-disable-next-line camelcase
                     name={homeFeature1Data?.button_name}
                  />
               </a>
            </View>
            {/* <View
               display="flex"
               flexFlow="column"
               alignItems="center"
               textAlign="center"
               width="100%[a-b] 33%[c-f]"
               padding="32px[a-b] 16px 32px[c-f]">
               <img
                  width="64px"
                  src="/assets/custom/gns3/images/home/3-observable.jpg"
                  alt="Icon"
               />
               <div className={style.featureTitle}>
                  <div className={style.highlightOrange}>
                     {homeFeature2Data?.title}
                  </div>
                  {homeFeature2Data?.subtitle}
               </div>
               <div className={style.featureSubtitle}>
                  {homeFeature2Data?.body}
               </div>
               eslint-disable-next-line jsx-a11y/anchor-is-valid
               <a
                  href={homeFeature2Data?.url}
                  onClick={() => handleAnalyticsClick('Thwack Camp - Homepage Ad Click')}
                  rel="noopener noreferrer"
                  target="_blank">
                  <Button
                     color="#ff6200"
                     // eslint-disable-next-line camelcase
                     name={homeFeature2Data?.button_name}
                  />
               </a>
            </View> */}
         </View>
      </div>
   )
}

export default HomeFeatures
